// extracted by mini-css-extract-plugin
export default {"wrapper":"G1-z","play":"H1-z"};